import {
  CustomField,
  CustomFieldFilters,
  CustomFieldFiltersTranslator,
  CustomFieldSortingOptionsConsts,
  customFieldConstants,
} from "../../../api/CustomFields/CustomFields";
import { DateTimeRenderer } from "../../datetime/DateTimeFormatter";
import { EntitySidebarTile, EntitySidebarTileProps } from "./EntitySidebarTile/EntitySidebarTile";
import { NotSet } from "../../misc/UIconstants";
import { AbstractedCustomFieldDataTypeIcon } from "../../../Customization/CustomFields/CustomFieldRenderUtils";
import { generateAbstractedFromDataType } from "../../../Customization/CustomFields/CustomFieldUtils";
// import { GetPersons } from "../../misc/EntityRenders/EntityRenderer";
import { defaultCustomFieldsFilters } from "../../../Customization/CustomFields/Table/CustomFieldsTable";

export const CustomFieldsTile = (props: EntitySidebarTileProps<CustomField, CustomFieldFilters>) => {
  return (
    <EntitySidebarTile<CustomField, CustomFieldFilters>
      {...props}
      entityConstants={customFieldConstants}
      orderByOptions={CustomFieldSortingOptionsConsts}
      translatorConsts={CustomFieldFiltersTranslator}
      defaultFilters={{ ...defaultCustomFieldsFilters, ...props.defaultFilters }}
      rowLabel={(e) => <>{e.name}</>}
      rowDate={(e) => (
        <>{e.enteredOn ? <DateTimeRenderer date={e.enteredOn} includeElapsed={false} includeTime={false} /> : NotSet}</>
      )}
      // rowInfo={(e) => <>{e.enteredBy ? <GetPersons persons={e.enteredBy} createLinks={false} /> : NotSet}</>}
      rowInfo={(e) => {
        const dataType = generateAbstractedFromDataType(e.dataType);
        return (
          <div className="flex row-nowrap align-center gap-5">
            {dataType.abstractedDataType}
            {dataType.isMulti && (
              <label className="label label-soft-success" style={{ margin: 0 }}>
                Multi
              </label>
            )}
          </div>
        );
      }}
      iconOverride={(e) => (
        <AbstractedCustomFieldDataTypeIcon dataType={generateAbstractedFromDataType(e?.dataType).abstractedDataType!} />
      )}
    />
  );
};
